const RefreshGrid = (store, tableKey, params, type, isBtnSearch) => {
  // params:自定义的传过来的param,
  // 定义param:对应tableKey的查询params
  const [context, param] = [
    store.getState().gridsInfo.context[tableKey],
    store.getState().gridsInfo.context[tableKey].params,
  ];

  if (type) {
    return store.getState().gridsInfo.fetchDataHandler.bind(context)(
      !1,
      Object.assign(param, params),
    );
  } else {
    return store.getState().gridsInfo.fetchDataHandler.bind(context)(
      !0,
      { ...param,
        isBtnSearch: isBtnSearch,
        ...params,
      },
    );
  }
};

export default RefreshGrid;



// WEBPACK FOOTER //
// ./src/AntD/utils/refreshGrid.js